export default __webpack_public_path__ + "static/media/10.1c9339d6.jpg";